import React, { useState } from 'react';
import { Modal, Button, Alert, Row } from 'antd';
import PropTypes from 'prop-types';
import Input from '../elements/input/Input';

const DeductLoyaltyPointsModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  userName,
}) => {
  const [points, setPoints] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResetForm = () => {
    setPoints('');
    setMessage('');
    setError('');
  };

  const validateInputs = () => {
    const parsed = Number(points);
    if (!points || isNaN(parsed)) {
      setError('Unesite broj poena.');
      return false;
    }
    if (!Number.isInteger(parsed) || parsed < 1) {
      setError('Broj poena mora biti pozitivan ceo broj.');
      return false;
    }
    setError('');
    return true;
  };

  const handleOk = async () => {
    if (!validateInputs()) return;
    await onConfirm(Number(points), message || undefined);
    handleResetForm();
  };

  const handleCancel = () => {
    handleResetForm();
    onClose();
  };

  return (
    <Modal
      className="create_user_modal"
      title="Oduzmi poene korisniku"
      open={isOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={handleOk}
          className="btn-primary"
          disabled={loading}
          style={{ width: '150px' }}
        >
          {loading ? 'Oduzimanje...' : 'Oduzmi poene'}
        </Button>,
      ]}
    >
      <form
        className="create_user_modal_form"
        layout="vertical"
        autoComplete="off"
      >
        <Row className="create_user_modal_row">
          <p style={{ marginBottom: 12 }}>
            Unesite broj poena koji želite da oduzmete korisniku{' '}
            {userName && <strong>{userName}</strong>}.
          </p>
          <div>
            <Input
              label="Broj poena"
              id="points"
              name="points"
              placeholder="npr. 50"
              value={points}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '' || (Number(val) <= 99999 && /^\d+$/.test(val))) {
                  setPoints(val);
                  setError('');
                }
              }}
            />
          </div>
          <p style={{ marginBottom: 12, marginTop: 12 }}>
            Unesite poruku (opciono).
          </p>
          <div style={{ marginTop: 12 }}>
            <Input
              label="Poruka (opciono)"
              id="message"
              name="message"
              placeholder="Razlog oduzimanja poena..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
        </Row>
        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}
      </form>
    </Modal>
  );
};

DeductLoyaltyPointsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  userName: PropTypes.string,
};

export default DeductLoyaltyPointsModal;
